import { initChartStore } from "../../components/chart/store/chartStore.js";
import { derived, get } from "svelte/store";
import GanttHelper from "../../components/ganttchart/GanttHelper.js";
import dayjs from "dayjs";

function* gen_dates(startDate, endDate) {
  let currentDate = new Date(startDate)
  while (currentDate <= endDate) {
    yield currentDate
    const nextDate = new Date(currentDate)
    nextDate.setDate(nextDate.getDate() + 1)
    currentDate = nextDate
  }
}

export function initMPSChartStore(initialValues) {
  const chartStore = initChartStore(initialValues)

  const CurrentDisplayedDates = derived(
    [
      chartStore.CurrentDisplayedStartDate,
      chartStore.CurrentDisplayedEndDate,
    ],
    ([CurrentDisplayedStartDate, CurrentDisplayedEndDate]) => {
      const returned = []
      for (const date of gen_dates(CurrentDisplayedStartDate, CurrentDisplayedEndDate)) {
        date.setHours(0, 0, 0, 0)
        returned.push({
          date,
          dateNumber: Math.floor(date.getTime() / (1000 * 60 * 60 * 24)),
          dateString: dayjs(date).format("YYYY/MM/DD"),
          startXInPercentage: 100 * GanttHelper._gantHelper_scale(
            date.getTime(),
            CurrentDisplayedEndDate.getTime(),
            CurrentDisplayedStartDate.getTime()
          ),
          endXInPercentage: 100 * GanttHelper._gantHelper_scale(
            Math.min(GanttHelper.GetNextDateGraduation(date, 'D').getTime(), CurrentDisplayedEndDate.getTime()),
            CurrentDisplayedEndDate.getTime(),
            CurrentDisplayedStartDate.getTime()
          )
        })
      }
      return returned
    })

  return {
    ...chartStore,
    CurrentDisplayedDates,
  }
}

/**
 * load configuration from storage and set the store values accordingly.
 * also subscribe the store values to save them in the storage if they change.
 * @param mpsChartStore
 * @param {string} chartName
 * @param mpsConfigurationStorage
 * @returns {Promise<void>}
 */
export async function attachConfigurationStorageToMPSChartStore(mpsChartStore, chartName, mpsConfigurationStorage) {
  const MPSConfiguration = await mpsConfigurationStorage.getConfiguration()
  // current displayed start date
  if (MPSConfiguration[chartName]?.currentDisplayedStartDate) {
    const savedDate = new Date(MPSConfiguration[chartName].currentDisplayedStartDate)
    // check if the saved date falls in the valid range
    if (savedDate.getTime() >= get(mpsChartStore.ValidStartDate).getTime() && savedDate.getTime() <= get(mpsChartStore.ValidEndDate).getTime()) {
      mpsChartStore.CurrentDisplayedStartDate.set(savedDate)
    }
  }
  mpsChartStore.CurrentDisplayedStartDate.subscribe(val => mpsConfigurationStorage.saveConfiguration({[chartName]: {currentDisplayedStartDate: val.toISOString()}}))

  // display span
  if (MPSConfiguration[chartName]?.displaySpanInSeconds) {
    mpsChartStore.DisplayedSpanInSeconds.set(MPSConfiguration[chartName].displaySpanInSeconds)
  }
  mpsChartStore.DisplayedSpanInSeconds.subscribe(val => {
    mpsConfigurationStorage.saveConfiguration({[chartName]: {displaySpanInSeconds: val}})
  })

  // row count
  if (MPSConfiguration[chartName]?.rowCount) {
    mpsChartStore.DisplayedRowCount.set(MPSConfiguration[chartName].rowCount)
  }
  mpsChartStore.DisplayedRowCount.subscribe(val => mpsConfigurationStorage.saveConfiguration({[chartName]: {rowCount: val}}))

  // rows displayed start
  if (MPSConfiguration[chartName]?.rowsDisplayedStart) {
    mpsChartStore.RowsDisplayedStart.set(MPSConfiguration[chartName].rowsDisplayedStart)
  }
  mpsChartStore.RowsDisplayedStart.subscribe(val => mpsConfigurationStorage.saveConfiguration({[chartName]: {rowsDisplayedStart: val}}))
}
